import { Drawer, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { PrimaryButton } from "../../_components/button/primary.button";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { TextValidatorHcs } from "../../_components/textValidator/textValidatorHcs";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { discountService } from "../../_services/discount.service";
import { useDrawerStyles } from "../../_styles/drawer.styles";
import moment from "moment";

export const DiscountManageDrawer = (params: { isOpen: boolean, itemId: number | null, onSave(): void, onClose(): void }) => {

    const resetData = () => ({
        id: 0,
        name: "",
        value: 0,
        code: "",
        startDate: "",
        expiryDate: ""
    });

    const [data, setData] = useState<any>(resetData);

    useEffect(() => {
        if (params.itemId != null)
            fetchData();
        else
            setData(resetData);
    }, [params.itemId, params.isOpen]);

    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    function fetchData() {
        if (!params.itemId) return;

        setIsLoading(true)
        return discountService
            .get(params.itemId)
            .then(
                (json) => {
                    setData({ ...json, startDate: moment(json.startDate).format('YYYY-MM-DD'), expiryDate: moment(json.expiryDate).format('YYYY-MM-DD') });
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        return discountService
            .submit(data)
            .then(
                () => {
                    toastr.success("Saved successfully");
                    params.onSave();
                },
                (e: any) => toastr.error(e)
            )
            .finally(() => setIsSaving(false));
    }

    function disable() {
        if (!params.itemId) return;
        setIsLoading(true);
        return discountService
            .disable(params.itemId)
            .then(
                (d: any) => {
                    toastr.success("Disabled successfully");
                    fetchData();
                    params.onSave();
                }, handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }))
    };


    return (

        <Drawer
            anchor={"right"}
            variant="persistent"
            open={params.isOpen}
            ModalProps={{
                keepMounted: true
            }}
        >

            <div
                tabIndex={0}
                role="button">

                <div>

                    <DrawerHeader name={(!!params.itemId) ? "Update Discount" : "Create Discount"} onClose={params.onClose} />

                    <ValidatorForm
                        onSubmit={submit}
                        noValidate>

                        <Grid container spacing={1} sx={useDrawerStyles.container}>
                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    key="name"
                                    name="name"
                                    label="Name"
                                    required
                                    fullWidth
                                    validators={['required', 'minStringLength:1']}
                                    errorMessages={['required field', "Field cannot be empty"]}
                                    value={data.name}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    key="value"
                                    name="value"
                                    label="% Value"
                                    required
                                    type="text"
                                    fullWidth
                                    validators={['required', 'minNumber:1', 'maxNumber:100']}
                                    errorMessages={['required field', "Value cannot be less than 1%", "Value cnanot be more than 100%"]}
                                    value={data.value}
                                    onChange={handleChange}
                                />


                            </Grid>

                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    key="code"
                                    name="code"
                                    label="Code"
                                    required
                                    fullWidth
                                    validators={['required', 'minStringLength:3']}
                                    errorMessages={['required field', "Field cannot be empty"]}
                                    value={data.code}
                                    onChange={handleChange}
                                />
                            </Grid>


                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    key="startDate"
                                    name="startDate"
                                    label="Start Date"
                                    required
                                    fullWidth
                                    type="date"
                                    validators={['required']}
                                    errorMessages={['required field']}
                                    value={data.startDate}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    key="expiryDate"
                                    name="expiryDate"
                                    label="Expiry Date"
                                    type="date"
                                    required
                                    fullWidth
                                    validators={['required', 'minStringLength:1']}
                                    errorMessages={['required field', "Field cannot be empty"]}
                                    value={data.expiryDate}
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} sx={useDrawerStyles.container}>

                            <Grid item xs={(data.id === 0 ? 12 : 6)}>
                                <PrimaryButton
                                    isSaving={isSaving}
                                    isLoading={isLoading}
                                    type="submit"
                                    variant="save">{"Save"}
                                </PrimaryButton>
                            </Grid>

                            {data.id > 0 &&
                                <Grid item xs={6}>
                                    <PrimaryButton
                                        type="button"
                                        variant="danger"
                                        disabled={isLoading}
                                        onClick={disable}
                                        icon="block"
                                    >
                                        Disable
                                    </PrimaryButton>
                                </Grid>
                            }

                        </Grid>

                    </ValidatorForm>
                </div>
            </div>
        </Drawer >
    );
};